import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { ROUTES } from "routes/routePaths";
import { formatAmount } from "utils/helper";
import { useNavigate } from "react-router-dom";
import { AiOutlineRight } from "react-icons/ai";
import { Typography, Carousel, LoadingSkeleton } from "components";
// import commissionEarnedImg from "assets/images/commission-earned.png";
import transactionVolumeImg from "assets/images/transaction-volume.png";
import terminalSuccessImg from "assets/images/terminal-success-rate.png";
import transactionValueImg from "assets/images/transaction-value.svg";
// import totalAmountSettledImg from "assets/images/total-amount-settled.svg";

import totalAssignedTerminalsImg from "assets/images/total-assigned-terminals.svg";
import {
  getTerminalSummary,
  getTerminalActivity,
} from "redux/actions/dashboard/terminalDashboardActions";

const SummaryCards = () => {
  const navigate = useNavigate();

  const { terminalActivity, terminalSummary, transactionTypeStats } =
    useSelector((state) => state.terminalDashboardReducer);

  const { data, loading } = terminalSummary;
  const { totalTransVolume, totalTransValue } =
    transactionTypeStats?.data || {};

  useEffect(() => {
    getTerminalSummary();
    getTerminalActivity();
  }, []);

  return (
    <>
      <div className="row g-0">
        <Carousel>
          {transactionTypeStats?.loading ? (
            <div className=" pt-3 px-2">
              <LoadingSkeleton height="6.7rem" />
            </div>
          ) : (
            <div className="terminal-stats-card p-2">
              <Typography variant="caption1">Transaction Volume</Typography>
              <div className="main-detail mt-xl-1">
                <Typography className="mt-1" state="primary">
                  {formatAmount(totalTransVolume)}
                </Typography>
                <img src={transactionVolumeImg} alt="" />
              </div>
            </div>
          )}
          {terminalActivity.loading ? (
            <div className=" pt-3 px-2">
              <LoadingSkeleton height="6.7rem" />
            </div>
          ) : (
            <div className="terminal-stats-card p-2">
              <Typography variant="caption1">Terminal Success Rate</Typography>
              <div className="main-detail mt-xl-1">
                <Typography className="mt-1" state="primary">
                  {terminalActivity.data?.successRate || 0}%
                </Typography>
                <img src={terminalSuccessImg} alt="" />
              </div>
            </div>
          )}
        </Carousel>
      </div>

      <div className="row g-0 space-top-2">
        <Carousel>
          {transactionTypeStats?.loading ? (
            <div className=" pt-3 px-2">
              <LoadingSkeleton height="6.7rem" />
            </div>
          ) : (
            <div className="terminal-stats-card p-2">
              <Typography variant="caption1">Transaction Value</Typography>
              <div className="main-detail mt-xl-1">
                <Typography className="mt-1" state="primary">
                  {formatAmount(totalTransValue)}
                </Typography>
                <img src={transactionValueImg} alt="" />
              </div>
            </div>
          )}

          {/* <div className="terminal-stats-card p-2">
            <Typography variant="caption1">Total Amount Settled</Typography>
            <div className="main-detail mt-xl-1">
              <Typography className="mt-1" state="primary">
                ₦{formatAmount(980000)}
              </Typography>
              <img src={totalAmountSettledImg} alt="" width="40" height="40" />
            </div>
          </div> */}

          {loading ? (
            <div className=" pt-3 px-2">
              <LoadingSkeleton height="6.7rem" />
            </div>
          ) : (
            <div
              className="terminal-stats-card p-2 cursor-pointer"
              onClick={() => navigate(ROUTES.terminals)}
            >
              <Typography variant="caption1">
                Total Assigned Terminals
              </Typography>
              <div className="main-detail mt-xl-1">
                <Typography className="mt-1" state="primary">
                  {data.registered || 0}
                </Typography>
                <img
                  src={totalAssignedTerminalsImg}
                  alt=""
                  style={{ width: "30px" }}
                />
              </div>
              <div className="d-flex justify-content-end pr-4 mt-3">
                <AiOutlineRight color="#3D3333" fontSize={"12px"} />
              </div>
            </div>
          )}
        </Carousel>
      </div>
    </>
  );
};

export default SummaryCards;
